import { ArrowUpRight, Mail, MessageCircle } from "lucide-react";
import { LINKS, NAV_ITEMS, scrollToSection } from "@/lib/site";

const ACTIONS = [
  { label: "Join Our Community", href: LINKS.community, testId: "footer-join-community-link" },
  { label: "Subscribe to Our Status", href: LINKS.status, testId: "footer-subscribe-status-link" },
  { label: "Advertise on JGW", href: LINKS.advertise, testId: "footer-advertise-link" },
];

const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-black">
    <div className="mx-auto max-w-7xl px-5 py-10 lg:px-10">
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="/jgw-logo.jpeg"
              alt="Jewish Global Wire"
              className="h-11 w-11 rounded-full object-cover ring-1 ring-white/20"
            />
            <p className="font-display text-base font-bold text-white">Jewish Global Wire</p>
          </div>
          <p className="mt-3 text-sm text-silver">
            Real News. Real Time. <span className="font-semibold text-whatsapp">Real Impact.</span>
          </p>
        </div>

        <div>
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-silver-dark">Contact</p>
          <ul className="mt-3.5 space-y-2.5 text-sm">
            <li>
              <a
                href={LINKS.phoneHref}
                data-testid="footer-phone-link"
                className="flex items-center gap-2.5 font-semibold text-silver transition-colors duration-200 hover:text-whatsapp"
              >
                <MessageCircle size={14} className="text-whatsapp" />
                {LINKS.phoneDisplay}
              </a>
            </li>
            <li>
              <a
                href={LINKS.statusPhoneHref}
                data-testid="footer-status-phone-link"
                className="flex items-center gap-2.5 font-semibold text-silver transition-colors duration-200 hover:text-whatsapp"
              >
                <MessageCircle size={14} className="text-whatsapp" />
                Status line: {LINKS.statusPhoneDisplay}
              </a>
            </li>
            <li>
              <a
                href={LINKS.email}
                data-testid="footer-email-link"
                className="flex items-center gap-2.5 font-semibold text-silver transition-colors duration-200 hover:text-white"
              >
                <Mail size={14} className="text-silver-light" />
                {LINKS.emailAddress}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-silver-dark">Navigate</p>
          <ul className="mt-3.5 space-y-2.5 text-sm">
            {NAV_ITEMS.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={(e) => scrollToSection(e, item.href)}
                  data-testid={`footer-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}-link`}
                  className="font-semibold text-silver transition-colors duration-200 hover:text-white"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-silver-dark">Get Started</p>
          <ul className="mt-3.5 space-y-2.5 text-sm">
            {ACTIONS.map((action) => (
              <li key={action.label}>
                <a
                  href={action.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={action.testId}
                  className="group inline-flex items-center gap-1.5 font-semibold text-silver transition-colors duration-200 hover:text-whatsapp"
                >
                  {action.label}
                  <ArrowUpRight
                    size={14}
                    strokeWidth={2}
                    className="transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                  />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-8 flex flex-col items-center justify-between gap-2 border-t border-white/10 pt-5 text-xs font-medium text-silver-dark sm:flex-row">
        <p data-testid="footer-copyright">
          © {new Date().getFullYear()} Jewish Global Wire. All rights reserved.
        </p>
        <p>Jewish News. Directly on WhatsApp.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
